module.exports = "/assets/data/45b31b16f2ebe2a39b6fde7d6b8e2b6e-DD10.data.json";